import { mergeStyleSets } from 'office-ui-fabric-react';

export const globalStyles = mergeStyleSets({
    fontStyles: {
        fontFamily: 'Segoe UI',
    },
});
